module.exports = __webpack_public_path__ + "img/会员生日提醒.07c027d6.png";